import { render, staticRenderFns } from "./VehicleTypeServiced.vue?vue&type=template&id=fec6c4ce"
import script from "./VehicleTypeServiced.vue?vue&type=script&lang=js"
export * from "./VehicleTypeServiced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports